export default "__VITE_ASSET__DOQv4zBG__"